import type { FC } from 'react';
import { CommonButton } from '@shared/ui';
import { AuthForm } from '@src/modules/Authentication/AuthFrom';
import CustomInput from '@src/modules/Authentication/CustomInput';
import { ModalError } from '@src/modules/Authentication/frames/modal-error';
import { PasswordHint } from '@src/modules/Authentication/frames/password-hint';
import * as st from './styles.module.scss';

interface Props {
  model: any;
}

export const PasswordStep: FC<Props> = ({ model }) => {
  const errorMessage =
    model?.passwordErrors?.password?.message ||
    model?.passwordErrors?.passwordRepeat?.message;
  return (
    <AuthForm onSubmit={model.submitForm((data: any) => model.confirmForm(data))}>
      <div className={st.password_block}>
        <CustomInput
          tabindex={0}
          type="password"
          label="Пароль"
          name="password"
          control={model.passwordControl}
          error={model.passwordErrors?.password}
          disabled={model.isLoading}
          showPassword={model.showPassword}
          setValue={() => {
            model.setShowPassword(!model.showPassword);
          }}
        />

        <CustomInput
          tabindex={0}
          type="password"
          label="Повторите пароль"
          name="passwordRepeat"
          control={model.passwordControl}
          error={model.passwordErrors?.passwordRepeat}
          disabled={model.isLoading}
          showPassword={model.showPasswordRepeat}
          setValue={() => {
            model.setShowPasswordRepeat(!model.showPasswordRepeat);
          }}
        />

        <PasswordHint />
      </div>

      {errorMessage ? (
        <ModalError error={errorMessage} />
      ) : (
        <div className={st.wrapper__long}>
          <CommonButton
            tabIndex={0}
            type="submit"
            disabled={model.isLoading}
            className={st.submitButton}
          >
            Зарегистрироваться
          </CommonButton>
        </div>
      )}
    </AuthForm>
  );
};
